const OverlayFormTeaser = () => {

    function init() {
        const domButtonClose = document.querySelector('.overlay-form-teaser-head-button-close')
        const domOverlay = document.querySelector('.overlay')
        let openAgain = true
        if (domButtonClose && domOverlay) {
            document.querySelector('.overlay-form-teaser-head-button-close').onclick = () => {
                domOverlay.style.display = 'none'
                if (openAgain === true) {
                    openAgain = false
                    setTimeout(() => domOverlay.style.display = 'block', 15000)
                }
                return false
            }
        }
    }

    return { init }
}

export default OverlayFormTeaser()
